import React from "react";
import ReactDOM from "react-dom/client";
/* ───────────────────────────────────────────────────────────────────────────
   AppShell — root layout wrapper (Phase A skeleton)
   ───────────────────────────────────────────────────────────────────────────
   Composes Sidebar + Topbar + content area for the new multi-page architecture.

   Phase A: this component is defined and exposed on window.AppShell but NOT
   yet rendered anywhere. Legacy app.jsx continues to mount directly into
   #root via ReactDOM.createRoot, so existing dashboard is unchanged.

   Phase C will introduce a new index.html / router that wraps the new
   Dashboard page inside AppShell. Phase B's components.html showcase may also
   use AppShell as a layout reference.

   Props:
     sidebar  — ReactNode rendered into <aside class="app-shell__sidebar">
     topbar   — ReactNode rendered into <header class="app-shell__topbar">
     children — ReactNode rendered into <div class="app-shell__content">

   Loading: <script type="text/babel" src="/src/components/AppShell.jsx"> —
   not loaded yet in Forecast.html (dead export). Phase B/C will wire it.

   Styling: classnames defined here; CSS lives in src/components/AppShell.css
   (to be authored in Phase B alongside the rest of the primitives).
   ─────────────────────────────────────────────────────────────────────────── */

export default function AppShell({ sidebar, topbar, children }) {
  return React.createElement(
    "div",
    { className: "app-shell" },
    sidebar
      ? React.createElement(
          "aside",
          { className: "app-shell__sidebar", role: "navigation", "aria-label": "Primary" },
          sidebar
        )
      : null,
    React.createElement(
      "main",
      { className: "app-shell__main" },
      topbar
        ? React.createElement(
            "header",
            { className: "app-shell__topbar", role: "banner" },
            topbar
          )
        : null,
      React.createElement(
        "div",
        { className: "app-shell__content" },
        children
      )
    )
  );
}

// Expose under both window.AppShell (legacy Phase A) and window.V2.AppShell
// (Phase B namespace) — same component, two access patterns.
